import store from "@/state/store";

export default [
  {
    path: "/login", 
    name: "login",
    component: () => import("../views/account/login.vue"),
    meta: {
      title: "Login",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
          next();
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/account/register.vue"),
    meta: {
      title: "Register",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("../views/account/forgot-password.vue"),
    meta: {
      title: "Forgot Password",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/",
    name: "default",
    meta: {
      title: "Dashboard",
      authRequired: true,
    },
    component: () => import("../views/dashboard/census-dashboard/index"), 
  },

  {
    path: "/pages/shapefileupload",
    name: "shapefileupload",
    meta: {
      title: "Shapefiles Upload", authRequired: true,
    },
    component: () => import("../views/pages/ShapefileUpload"),
  },

  {
    path: "/dashboard/census-dashboard",
    name: "census-dashboard",
    meta: {
      title: "Census Dashboard", authRequired: true,
    },
    component: () => import("../views/dashboard/census-dashboard/index"),
  },
  {
    path: "/dashboard/marine-biodiversity",
    name: "dashboard-marine-biodiversity",
    meta: {
      title: "Marine Biodiversity", authRequired: true,
    },
    component: () => import("../views/dashboard/marine-biodiversity/index"),
  },
  {
    path: "/dashboard/ecosystem-overview",
    name: "dashboard-ecosystem-overview",
    meta: {
      title: "Ecosystem Overview", authRequired: true,
    },
    component: () => import("../views/dashboard/ecosystem-overview/index"),
  },
  {
    path: "/dashboard/species-conservation",
    name: "dashboard-species-conservation",
    meta: {
      title: "Species & Conservation", authRequired: true,
    },
    component: () => import("../views/dashboard/species-conservation/index"),
  },  {
    path: "/dashboard/wildlife-tracking",
    name: "dashboard-wildlife-tracking",
    meta: {
      title: "Wildlife Tracking & Alerts", authRequired: true,
    },
    component: () => import("../views/dashboard/wildlife-tracking/index"),
  },
  {
    path: "/dashboard/wildlife-health-monitoring",
    name: "dashboard-wildlife-health-monitoring",
    meta: {
      title: "Wildlife Health Monitoring", authRequired: true,
    },
    component: () => import("../views/dashboard/wildlife-health-monitoring"),
  },
  {
    path: "/dashboard/climate-environmental",
    name: "dashboard-climate-environmental",
    meta: {
      title: "Climate & Environmental", authRequired: true,
    },
    component: () => import("../views/dashboard/climate-environmental/index"),
  },
  {
    path: "/dashboard/research-publications",
    name: "dashboard-research-publications",
    meta: {
      title: "Research and Publications", authRequired: true,
    },
    component: () => import("../views/dashboard/research-publications/index"),
  },
  {
    path: "/dashboard/national-overview",
    name: "dashboard-national-overview",
    meta: {
      title: "National Overview", authRequired: true,
    },
    component: () => import("../views/dashboard/national-overview/index.vue"),
  },
  {
    path: "/dashboard/land-statistics",
    name: "dashboard-land-statistics",
    meta: {
      title: "Land Statistics", authRequired: true,
    },
    component: () => import("../views/dashboard/land-statistics/index.vue"),
  },
  {
    path: "/dashboard/performance",
    name: "dashboard-performance",
    meta: {
      title: "Performance Monitoring", authRequired: true,
    },
    component: () => import("../views/performance/PerformanceDashboard"),
  },
  {
    path: "/dashboard/analytics",
    name: "dashboard-analytics",
    meta: {
      title: "Advanced Analytics", authRequired: true,
    },
    component: () => import("../views/analytics/AnalyticsDashboard"),
  },
  {
    path: "/dashboard/weather-dashboard",
    name: "dashboard-weather-dashboard",
    meta: {
      title: "Weather Dashboard", authRequired: true,
    },
    component: () => import("../views/dashboard/weather-dashboard/index"),
  },
  {
    path: "/gis/map-dashboard",
    name: "gis-map-dashboard",
    meta: {
      title: "GIS Map Dashboard", authRequired: true,
    },
    component: () => import("../views/gis/MapDashboard"),
  },
  {
    path: "/reports/speciesdistribution",
    name: "speciesdistribution",
    meta: {
      title: "Species Distribution", authRequired: true,
    },
    component: () => import("../views/reports/SpeciesDistribution"),
  },
  {
    path: "/reports/temporalanalysis",
    name: "temporalanalysis",
    meta: {
      title: "Temporal Analysis & Trend", authRequired: true,
    },
    component: () => import("../views/reports/TemporalAnalysis"),
  },
  {
    path: "/reports/speciesrichness",
    name: "speciesrichness",
    meta: {
      title: "Species Richness & Biodiversity Metrics", authRequired: true,
    },
    component: () => import("../views/reports/SpeciesMetrics"),
  },
  {
    path: "/reports/comparativeanalytics",
    name: "comparativeanalytics",
    meta: {
      title: "Comparative Analytics", authRequired: true,
    },
    component: () => import("../views/reports/CommunityEngagement"),
  },
  {
    path: "/reports/threatconservationanalysis",
    name: "threatconservationanalysis",
    meta: {
      title: "Threat & Conservation Analysis", authRequired: true,
    },
    component: () => import("../views/reports/ThreatConservationAnalysis"),
  },
  {
    path: "/reports/communityengagement",
    name: "communityengagement",
    meta: {
      title: "Community Engagement", authRequired: true,
    },
    component: () => import("../views/reports/CommunityEngagement"),
  },
  {
    path: "/reports/er",
    name: "er",
    meta: {
      title: "Earth Ranger", authRequired: true,
    },
    component: () => import("../views/reports/er"),
  },
  {
    path: "/reports/gismap",
    name: "gismap",
    meta: {
      title: "GIS Map", authRequired: true,
    },
    component: () => import("../views/reports/GISMap"),
  },
  {
    path: "/reports/wrtiecosystems",
    name: "wrtiecosystems",
    meta: {
      title: "WRTI Ecosystems", authRequired: true,
    },
    component: () => import("../views/reports/WRTIEcosystemsMap"),
  },
  // Census Reports Routes
  {
    path: "/reports/census/species-summary",
    name: "census-species-summary",
    meta: {
      title: "Species Population Summary", authRequired: true,
    },
    component: () => import("../views/reports/census/species-summary/index.vue"),
  },
  {
    path: "/reports/census/survey-coverage",
    name: "census-survey-coverage",
    meta: {
      title: "Survey Coverage Analysis", authRequired: true,
    },
    component: () => import("../views/reports/census/survey-coverage/index.vue"),
  },
  {
    path: "/reports/census/temporal-trends",
    name: "census-temporal-trends",
    meta: {
      title: "Temporal Trends Analysis", authRequired: true,
    },
    component: () => import("../views/reports/census/temporal-trends/index.vue"),
  },
  {
    path: "/reports/census/geographic-distribution",
    name: "census-geographic-distribution",
    meta: {
      title: "Geographic Distribution", authRequired: true,
    },
    component: () => import("../views/reports/census/geographic-distribution/index.vue"),
  },
  {
    path: "/reports/census/data-quality",
    name: "census-data-quality",
    meta: {
      title: "Data Quality Assessment", authRequired: true,
    },
    component: () => import("../views/reports/census/data-quality/index.vue"),
  },
  
  // Census Analytics Reports Routes
  {
    path: "/reports/census/analytics/spatial-degradation",
    name: "census-analytics-spatial-degradation",
    meta: {
      title: "Spatial Degradation Analysis", authRequired: true,
    },
    component: () => import("../views/reports/census/analytics/spatial-degradation/index.vue"),
  },
  {
    path: "/reports/census/analytics/pca-analysis",
    name: "census-analytics-pca-analysis",
    meta: {
      title: "Principal Component Analysis", authRequired: true,
    },
    component: () => import("../views/reports/census/analytics/pca-analysis/index.vue"),
  },
  {
    path: "/reports/census/analytics/lollipop-charts",
    name: "census-analytics-lollipop-charts",
    meta: {
      title: "Lollipop Charts Visualization", authRequired: true,
    },
    component: () => import("../views/reports/census/analytics/lollipop-charts/index.vue"),
  },
  {
    path: "/reports/census/analytics/temperature-correlation",
    name: "census-analytics-temperature-correlation",
    meta: {
      title: "Temperature vs Species Correlation", authRequired: true,
    },
    component: () => import("../views/reports/census/analytics/temperature-correlation/index.vue"),
  },
  {
    path: "/reports/census/analytics/regression-statistics",
    name: "census-analytics-regression-statistics",
    meta: {
      title: "Regression Statistics", authRequired: true,
    },
    component: () => import("../views/reports/census/analytics/regression-statistics/index.vue"),
  },
  {
    path: "/reports/census/analytics/climate-correlation",
    name: "census-analytics-climate-correlation",
    meta: {
      title: "Climate Correlation Matrices", authRequired: true,
    },
    component: () => import("../views/reports/census/analytics/climate-correlation/index.vue"),
  },
  {
    path: "/reports/census/analytics/incident-frequency",
    name: "census-analytics-incident-frequency",
    meta: {
      title: "Incident Frequency Distribution", authRequired: true,
    },
    component: () => import("../views/reports/census/analytics/incident-frequency/index.vue"),
  },
  {
    path: "/reports/census/analytics/cluster-analysis",
    name: "census-analytics-cluster-analysis",
    meta: {
      title: "Cluster Analysis", authRequired: true,
    },
    component: () => import("../views/reports/census/analytics/cluster-analysis/index.vue"),
  },
  {
    path: "/reports/census/analytics/pattern-recognition",
    name: "census-analytics-pattern-recognition",
    meta: {
      title: "Pattern Recognition", authRequired: true,
    },
    component: () => import("../views/reports/census/analytics/pattern-recognition/index.vue"),
  },
  {
    path: "/reports/census/analytics/pachymed-analysis",
    name: "census-analytics-pachymed-analysis",
    meta: {
      title: "Pachymed Data Analysis", authRequired: true,
    },
    component: () => import("../views/reports/census/analytics/pachymed-analysis/index.vue"),
  },
  {
    path: "/reports/census/analytics/flare-analysis",
    name: "census-analytics-flare-analysis",
    meta: {
      title: "Flare Analysis", authRequired: true,
    },
    component: () => import("../views/reports/census/analytics/flare-analysis/index.vue"),
  },
  {
    path: "/reports/census/analytics/invasive-monitoring",
    name: "census-analytics-invasive-monitoring",
    meta: {
      title: "Invasive Species Monitoring", authRequired: true,
    },
    component: () => import("../views/reports/census/analytics/invasive-monitoring/index.vue"),
  },
  {
    path: "/reports/census/analytics/hotspot-mapping",
    name: "census-analytics-hotspot-mapping",
    meta: {
      title: "Hotspot Mapping", authRequired: true,
    },
    component: () => import("../views/reports/census/analytics/hotspot-mapping/index.vue"),
  },
  {
    path: "/reports/census/analytics/risk-scoring",
    name: "census-analytics-risk-scoring",
    meta: {
      title: "Risk Scoring Analysis", authRequired: true,
    },
    component: () => import("../views/reports/census/analytics/risk-scoring/index.vue"),
  },
  {
    path: "/reports/census/analytics/temporal-patterns",
    name: "census-analytics-temporal-patterns",
    meta: {
      title: "Temporal Pattern Analysis", authRequired: true,
    },
    component: () => import("../views/reports/census/analytics/temporal-patterns/index.vue"),
  },
  {
    path: "/reports/census/analytics/seasonal-trends",
    name: "census-analytics-seasonal-trends",
    meta: {
      title: "Seasonal Trends", authRequired: true,
    },
    component: () => import("../views/reports/census/analytics/seasonal-trends/index.vue"),
  },
  {
    path: "/reports/census/analytics/predictive-risk",
    name: "census-analytics-predictive-risk",
    meta: {
      title: "Predictive Risk Modeling", authRequired: true,
    },
    component: () => import("../views/reports/census/analytics/predictive-risk/index.vue"),
  },
  {
    path: "/reports/census/analytics/species-checklists",
    name: "census-analytics-species-checklists",
    meta: {
      title: "Species Checklists Analysis", authRequired: true,
    },
    component: () => import("../views/reports/census/analytics/species-checklists/index.vue"),
  },
  {
    path: "/species/national-status",
    name: "species-national-status",
    meta: {
      title: "Species National Status", authRequired: true,
    },
    component: () => import("../views/species/NationalStatus.vue"),
  },
  {
    path: "/reports/census/analytics/biodiversity-profiling",
    name: "census-analytics-biodiversity-profiling",
    meta: {
      title: "Biodiversity Profiling", authRequired: true,
    },
    component: () => import("../views/reports/census/analytics/biodiversity-profiling/index.vue"),
  },
  {
    path: "/reports/census/analytics/spatial-validation",
    name: "census-analytics-spatial-validation",
    meta: {
      title: "Spatial Data Validation", authRequired: true,
    },
    component: () => import("../views/reports/census/analytics/spatial-validation/index.vue"),
  },
  {
    path: "/reports/census/analytics/coverage-gap",
    name: "census-analytics-coverage-gap",
    meta: {
      title: "Coverage Gap Analysis", authRequired: true,
    },
    component: () => import("../views/reports/census/analytics/coverage-gap/index.vue"),
  },
  {
    path: "/reports/census/analytics/threatened-species",
    name: "census-analytics-threatened-species",
    meta: {
      title: "Threatened Species Mapping", authRequired: true,
    },
    component: () => import("../views/reports/census/analytics/threatened-species/index.vue"),
  },
  {
    path: "/reports/census/analytics/conservation-priority",
    name: "census-analytics-conservation-priority",
    meta: {
      title: "Conservation Priority Analysis", authRequired: true,
    },
    component: () => import("../views/reports/census/analytics/conservation-priority/index.vue"),
  },
  {
    path: "/reports/census/analytics/cross-platform-results",
    name: "census-analytics-cross-platform-results",
    meta: {
      title: "Cross-platform Results", authRequired: true,
    },
    component: () => import("../views/reports/census/analytics/cross-platform-results/index.vue"),
  },
  {
    path: "/reports/census/analytics/species-incident-summary",
    name: "census-analytics-species-incident-summary",
    meta: {
      title: "Species Incident Summary", authRequired: true,
    },
    component: () => import("../views/reports/census/analytics/species-incident-summary/index.vue"),
  },
  
  // Rainfall Reports Routes
  {
    path: "/reports/rainfall/rainfall-summary",
    name: "rainfall-summary",
    meta: {
      title: "Rainfall Summary Report", authRequired: true,
    },
    component: () => import("../views/reports/rainfall/rainfall-summary/index.vue"),
  },
  {
    path: "/reports/rainfall/data-quality",
    name: "rainfall-data-quality",
    meta: {
      title: "Rainfall Data Quality Assessment", authRequired: true,
    },
    component: () => import("../views/reports/rainfall/data-quality/index.vue"),
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      title: "Logout", authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        localStorage.clear();
        sessionStorage.clear();
        next();
      },
    },
    component: () => import("../views/auth/logout/basic")
  },
  {
    path: "/main-calendar",
    name: "main-calendar",
    meta: { title: "Calendar", authRequired: true },
    component: () => import("../views/calendar/main"),
  },
  {
    path: "/cms/media",
    name: "media",
    meta: { title: "CMS Media", authRequired: true },
    component: () => import("../views/cms/media"),
  },
  {
    path: "/cms/categories",
    name: "categories",
    meta: { title: "CMS Categories", authRequired: true },
    component: () => import("../views/cms/categories"),
  },
  {
    path: "/cms/tags",
    name: "tags",
    meta: { title: "Tags", authRequired: true },
    component: () => import("../views/cms/tags"),
  },
  {
    path: "/cms/posts",
    name: "posts",
    meta: { title: "Posts", authRequired: true },
    component: () => import("../views/cms/posts"),
  },
  {
    path: "/cms/pages",
    name: "pages",
    meta: { title: "Pages", authRequired: true },
    component: () => import("../views/cms/pages"),
  },
  {
    path: "/cms/menu-items",
    name: "menu-items",
    meta: { title: "Menu Items", authRequired: true },
    component: () => import("../views/cms/menuItems"),
  },
  {
    path: "/cms/menu-items/:menuId",
    name: "menu-items",
    meta: { title: "Menu Items", authRequired: true },
    component: () => import("../views/cms/menuItems"),
    props: true, // Pass route params as props
  },
  {
    path: "/cms/menus",
    name: "menus",
    meta: { title: "Menus", authRequired: true },
    component: () => import("../views/cms/menus"),
  },
  {
    path: "/cms/enhanced-pages",
    name: "enhanced-pages",
    meta: { title: "Enhanced CMS Pages", authRequired: true },
    component: () => import("../views/cms/enhanced-pages"),
  },
  {
    path: "/cms/page-editor",
    name: "cms-page-editor-create",
    meta: { title: "Create Page", authRequired: true },
    component: () => import("../views/cms/page-editor"),
  },
  {
    path: "/cms/page-editor/:id",
    name: "cms-page-editor-edit",
    meta: { title: "Edit Page", authRequired: true },
    component: () => import("../views/cms/page-editor"),
  },
  {
    path: "/cms/content-blocks",
    name: "content-blocks",
    meta: { title: "Content Blocks", authRequired: true },
    component: () => import("../views/cms/content-blocks"),
  },
  {
    path: "/cms/tables",
    name: "cms-tables",
    meta: { title: "CMS Tables", authRequired: true },
    component: () => import("../views/cms/tables"),
  },
  {
    path: "/mailbox",
    name: "mailbox",
    meta: { title: "Mailbox", authRequired: true },
    component: () => import("../views/apps/email/mailbox"),
  },
  {
    path: "/email/email-basic",
    name: "email-basic",
    meta: { title: "Basic Action", authRequired: true },
    component: () => import("../views/apps/email/email-basic"),
  },
  {
    path: "/email/email-ecommerce",
    name: "email-ecommerce",
    meta: { title: "Ecommerce Action", authRequired: true },
    component: () => import("../views/apps/email/email-ecommerce"),
  },
  {
    path: "/apps/nft-auction",
    name: "auction",
    meta: { title: "Live Auction", authRequired: true },
    component: () => import("../views/apps/nft/nft-auction"),
  },
  {
    path: "/apps/nft-collection",
    name: "collection",
    meta: { title: "Collactions", authRequired: true },
    component: () => import("../views/apps/nft/nft-collection"),
  },
  {
    path: "/apps/nft-create",
    name: "create",
    meta: { title: "Create", authRequired: true },
    component: () => import("../views/apps/nft/nft-create"),
  },
  {
    path: "/apps/nft-creators",
    name: "creators",
    meta: { title: "Creators", authRequired: true },
    component: () => import("../views/apps/nft/nft-creators"),
  },
  {
    path: "/apps/nft-explore",
    name: "explore",
    meta: { title: "Explore Now", authRequired: true },
    component: () => import("../views/apps/nft/nft-explore"),
  },
  {
    path: "/apps/nft-item-detail",
    name: "item-detail",
    meta: { title: "Item Detail", authRequired: true },
    component: () => import("../views/apps/nft/nft-item-detail"),
  },
  {
    path: "/apps/nft-marketplace",
    name: "marketplace",
    meta: { title: "Marketplace", authRequired: true },
    component: () => import("../views/apps/nft/nft-marketplace"),
  },
  {
    path: "/apps/nft-ranking",
    name: "ranking",
    meta: { title: "Ranking", authRequired: true },
    component: () => import("../views/apps/nft/nft-ranking"),
  },
  {
    path: "/apps/nft-wallet",
    name: "nft-wallet",
    meta: { title: "Wallet", authRequired: true },
    component: () => import("../views/apps/nft/nft-wallet"),
  },
  {
    path: "/apps/projects-list",
    name: "projects-list",
    meta: { title: "Projects List", authRequired: true },
    component: () => import("../views/apps/projects/list"),
  },
  {
    path: "/apps/projects-overview",
    name: "projects Overview",
    meta: { title: "Projects Overview", authRequired: true },
    component: () => import("../views/apps/projects/overview"),
  },
  {
    path: "/apps/projects-create",
    name: "projects-create",
    meta: { title: "Projects Create", authRequired: true },
    component: () => import("../views/apps/projects/create"),
  },
  {
    path: "/apps/tasks-details",
    name: "tasks-details",
    meta: { title: "Tasks Details", authRequired: true },
    component: () => import("../views/apps/tasks/details"),
  },
  {
    path: "/apps/tasks-kanban",
    name: "tasks-kanban",
    meta: { title: "Tasks Kanban", authRequired: true },
    component: () => import("../views/apps/tasks/kanban"),
  },
  {
    path: "/apps/tasks-list-view",
    name: "tasks-list-view",
    meta: { title: "Taks List", authRequired: true },
    component: () => import("../views/apps/tasks/list-view"),
  },
  {
    path: "/apps/tickets-details",
    name: "tickets-details",
    meta: { title: "Ticket Details", authRequired: true },
    component: () => import("../views/tickets/details"),
  },
  {
    path: "/apps/tickets-list",
    name: "tickets-list",
    meta: { title: "Tickets List", authRequired: true },
    component: () => import("../views/tickets/list"),
  },
  {
    path: "/apps/crm-contacts",
    name: "crm-contacts",
    meta: { title: "CRM Contacts", authRequired: true },
    component: () => import("../views/apps/crm/contacts"),
  },
  {
    path: "/apps/crm-companies",
    name: "crm-companies",
    meta: { title: "CRM companies", authRequired: true },
    component: () => import("../views/apps/crm/companies"),
  },
  {
    path: "/apps/crm-deals",
    name: "crm-deals",
    meta: { title: "CRM Deals", authRequired: true },
    component: () => import("../views/apps/crm/deals"),
  },
  {
    path: "/apps/crm-leads",
    name: "crm-leads",
    meta: { title: "CRM Leads", authRequired: true },
    component: () => import("../views/apps/crm/leads"),
  },
  {
    path: "/ecommerce/customers",
    name: "customers",
    meta: { title: "Customers", authRequired: true },
    component: () => import("../views/apps/ecommerce/customers"),
  },
  {
    path: "/ecommerce/products",
    name: "products",
    meta: { title: "Products", authRequired: true },
    component: () => import("../views/apps/ecommerce/products"),
  },
  {
    path: "/ecommerce/product-details",
    name: "product-detail",
    meta: { title: "Product Details", authRequired: true },
    component: () => import("../views/apps/ecommerce/product-details"),
  },
  {
    path: "/ecommerce/orders",
    name: "orders",
    meta: { title: "Orders", authRequired: true },
    component: () => import("../views/apps/ecommerce/orders"),
  },
  {
    path: "/ecommerce/order-details",
    name: "order-details",
    meta: { title: "Order Details", authRequired: true },
    component: () => import("../views/apps/ecommerce/order-details"),
  },
  {
    path: "/ecommerce/add-product",
    name: "add-product",
    meta: { title: "Create Product", authRequired: true },
    component: () => import("../views/apps/ecommerce/add-product"),
  },
  {
    path: "/ecommerce/shopping-cart",
    name: "shopping cart",
    meta: { title: "Shopping Cart", authRequired: true },
    component: () => import("../views/apps/ecommerce/shopping-cart"),
  },
  {
    path: "/ecommerce/checkout",
    name: "checkout",
    meta: { title: "Check Out", authRequired: true },
    component: () => import("../views/apps/ecommerce/checkout"),
  },
  {
    path: "/ecommerce/sellers",
    name: "sellers",
    meta: { title: "Sellers", authRequired: true },
    component: () => import("../views/apps/ecommerce/sellers"),
  },
  {
    path: "/ecommerce/seller-details",
    name: "seller-details",
    meta: { title: "Seller Details", authRequired: true },
    component: () => import("../views/apps/ecommerce/seller-details"),
  },
  {
    path: "/crypto/buy-sell",
    name: "buy/sell",
    meta: { title: "Buy & Sell", authRequired: true },
    component: () => import("../views/apps/crypto/buy-sell"),
  },
  {
    path: "/crypto/kyc",
    name: "kyc",
    meta: { title: "KYC Application", authRequired: true },
    component: () => import("../views/apps/crypto/kyc"),
  },
  {
    path: "/crypto/ico",
    name: "ico",
    meta: { title: "ICO List", authRequired: true },
    component: () => import("../views/apps/crypto/ico"),
  },
  {
    path: "/crypto/orders",
    name: "crypto-orders",
    meta: { title: "Orders", authRequired: true },
    component: () => import("../views/apps/crypto/orders"),
  },
  {
    path: "/crypto/wallet",
    name: "wallet",
    meta: { title: "My Wallet", authRequired: true },
    component: () => import("../views/apps/crypto/wallet"),
  },
  {
    path: "/crypto/transactions",
    name: "transactions",
    meta: { title: "Transactions", authRequired: true },
    component: () => import("../views/apps/crypto/transactions"),
  },
  {
    path: "/invoices/detail/:id?",
    name: "invoice-detail",
    meta: { title: "Invoice Details", authRequired: true },
    component: () => import("../views/apps/invoices/details"),
  },
  {
    path: "/invoices/list",
    name: "invoice-list",
    meta: { title: "Invoice List", authRequired: true },
    component: () => import("../views/apps/invoices/list"),
  },
  {
    path: "/invoices/create",
    name: "invoice-create",
    meta: { title: "Create Invoice", authRequired: true },
    component: () => import("../views/apps/invoices/create"),
  },
  {
    path: "/jobs/application",
    name: "job-application",
    meta: { title: "Job Application", authRequired: true },
    component: () => import("../views/apps/jobs/application"),
  },
  {
    path: "/jobs/candidate-grid",
    name: "job-candidate-grid",
    meta: { title: "Candidate Grid", authRequired: true },
    component: () => import("../views/apps/jobs/candidate-grid"),
  },
  {
    path: "/jobs/candidate-lists",
    name: "job-candidate-lists",
    meta: { title: "Candidate Lists", authRequired: true },
    component: () => import("../views/apps/jobs/candidate-lists"),
  },
  {
    path: "/jobs/categories",
    name: "job-categories",
    meta: { title: "Job Categories", authRequired: true },
    component: () => import("../views/apps/jobs/categories"),
  },
  {
    path: "/jobs/companies-list",
    name: "job-companies-list",
    meta: { title: "Companies List", authRequired: true },
    component: () => import("../views/apps/jobs/companies-list"),
  },
  {
    path: "/jobs/details",
    name: "job-details",
    meta: { title: "Job Details", authRequired: true },
    component: () => import("../views/apps/jobs/details"),
  },
  {
    path: "/jobs/grid-lists",
    name: "job-grid-lists",
    meta: { title: "Grid Lists", authRequired: true },
    component: () => import("../views/apps/jobs/grid-lists"),
  },
  {
    path: "/jobs/lists",
    name: "job-lists",
    meta: { title: "Job Lists", authRequired: true },
    component: () => import("../views/apps/jobs/lists"),
  },
  {
    path: "/jobs/new",
    name: "job-new",
    meta: { title: "New Job", authRequired: true },
    component: () => import("../views/apps/jobs/new"),
  },
  {
    path: "/jobs/statistics",
    name: "job-statistics",
    meta: { title: "Job Statistics", authRequired: true },
    component: () => import("../views/apps/jobs/statistics"),
  },
  {
    path: "/apps-api-key",
    name: "API Key",
    meta: { title: "API Key", authRequired: true },
    component: () => import("../views/apps/apikey"),
  },

  {
    path: "/ui/alerts",
    name: "Alerts",
    meta: {
      title: "Alerts", authRequired: true,
    },
    component: () => import("../views/ui/alerts"),
  },
  {
    path: "/ui/buttons",
    name: "Buttons",
    meta: {
      title: "Buttons", authRequired: true,
    },
    component: () => import("../views/ui/buttons"),
  },
  {
    path: "/ui/cards",
    name: "Cards",
    meta: { title: "Cards", authRequired: true },
    component: () => import("../views/ui/cards"),
  },
  {
    path: "/ui/carousel",
    name: "Carousel",
    meta: { title: "Carousel", authRequired: true },
    component: () => import("../views/ui/carousel"),
  },
  {
    path: "/ui/dropdowns",
    name: "Dropdowns",
    meta: { title: "Dropdowns", authRequired: true },
    component: () => import("../views/ui/dropdowns"),
  },
  {
    path: "/ui/grid",
    name: "Grid",
    meta: { title: "Grid", authRequired: true },
    component: () => import("../views/ui/grid"),
  },
  {
    path: "/ui/images",
    name: "Images",
    meta: { title: "Images", authRequired: true },
    component: () => import("../views/ui/images"),
  },
  {
    path: "/ui/modals",
    name: "Modals",
    meta: { title: "Modals", authRequired: true },
    component: () => import("../views/ui/modals"),
  },
  {
    path: "/ui/offcanvas",
    name: "offcanvas",
    meta: { title: "Offcanvas", authRequired: true },
    component: () => import("../views/ui/offcanvas"),
  },
  {
    path: "/ui/progress",
    name: "Progress",
    meta: { title: "Progress", authRequired: true },
    component: () => import("../views/ui/progress"),
  },
  {
    path: "/ui/placeholders",
    name: "Placeholders",
    meta: { title: "Placeholders", authRequired: true },
    component: () => import("../views/ui/placeholders"),
  },
  {
    path: "/ui/accordions",
    name: "accordions",
    meta: { title: "Accordions", authRequired: true },
    component: () => import("../views/ui/accordions"),
  },
  {
    path: "/ui/tabs",
    name: "tabs",
    meta: { title: "Tabs", authRequired: true },
    component: () => import("../views/ui/tabs"),
  },
  {
    path: "/ui/typography",
    name: "Typography",
    meta: { title: "Typography", authRequired: true },
    component: () => import("../views/ui/typography"),
  },
  {
    path: "/ui/embed-video",
    name: "embed-video",
    meta: { title: "Embed Video", authRequired: true },
    component: () => import("../views/ui/embed-video"),
  },
  {
    path: "/ui/ribbons",
    name: "ribbons",
    meta: { title: "Ribbons", authRequired: true },
    component: () => import("../views/ui/ribbons"),
  },
  {
    path: "/ui/lists",
    name: "lists",
    meta: { title: "Lists", authRequired: true },
    component: () => import("../views/ui/lists"),
  },
  {
    path: "/ui/links",
    name: "links",
    meta: { title: "Links", authRequired: true },
    component: () => import("../views/ui/links"),
  },
  {
    path: "/ui/utilities",
    name: "utilities",
    meta: { title: "Utilities", authRequired: true },
    component: () => import("../views/ui/utilities"),
  },
  {
    path: "/ui/notifications",
    name: "notifications",
    meta: { title: "Notifications", authRequired: true },
    component: () => import("../views/ui/notifications"),
  },
  {
    path: "/ui/general",
    name: "General",
    meta: { title: "General", authRequired: true },
    component: () => import("../views/ui/general"),
  },
  {
    path: "/ui/colors",
    name: "Colors",
    meta: { title: "Colors", authRequired: true },
    component: () => import("../views/ui/colors"),
  },
  {
    path: "/ui/badges",
    name: "badges",
    meta: { title: "Badges", authRequired: true },
    component: () => import("../views/ui/badges"),
  },
  {
    path: "/widgets",
    name: "widgets",
    meta: { title: "Widgets", authRequired: true },
    component: () => import("../views/widgets/index"),
  },
  {
    path: "/icons/boxicons",
    name: "boxicons-icon",
    meta: { title: "Boxicons", authRequired: true },
    component: () => import("../views/icons/boxicons"),
  },
  {
    path: "/icons/materialdesign",
    name: "Material Design",
    meta: { title: "Material Design", authRequired: true },
    component: () => import("../views/icons/materialdesign"),
  },
  {
    path: "/icons/feather",
    name: "feather",
    meta: { title: "Feather", authRequired: true },
    component: () => import("../views/icons/feather"),
  },
  {
    path: "/icons/lineawesome",
    name: "lineawesome",
    meta: { title: "Line Awesome", authRequired: true },
    component: () => import("../views/icons/lineawesome"),
  },
  {
    path: "/icons/remix",
    name: "remix",
    meta: { title: "Remix", authRequired: true },
    component: () => import("../views/icons/remix"),
  },
  {
    path: "/icons/crypto",
    name: "crypto",
    meta: { title: "Crypto", authRequired: true },
    component: () => import("../views/icons/crypto"),
  },
  {
    path: "/tables/basic",
    name: "basic-table",
    meta: { title: "Basic Table", authRequired: true },
    component: () => import("../views/tables/basic"),
  },
  {
    path: "/tables/gridjs",
    name: "gridjs",
    meta: { title: "Grid JS", authRequired: true },
    component: () => import("../views/tables/grid/index"),
  },
  {
    path: "/form/advanced",
    name: "form-advanced",
    meta: { title: "Form Advance", authRequired: true },
    component: () => import("../views/forms/advanced"),
  },
  {
    path: "/form/elements",
    name: "form-elements",
    meta: { title: "Form Elements", authRequired: true },
    component: () => import("../views/forms/elements"),
  },
  {
    path: "/form/layouts",
    name: "Form Layouts",
    meta: { title: "Form Layouts", authRequired: true },
    component: () => import("../views/forms/layouts"),
  },
  {
    path: "/form/editors",
    name: "Form Editors",
    meta: { title: "Form Editors", authRequired: true },
    component: () => import("../views/forms/editors"),
  },
  {
    path: "/form/file-uploads",
    name: "File Uploads",
    meta: { title: "File Uploads", authRequired: true },
    component: () => import("../views/forms/file-uploads"),
  },
  {
    path: "/form/validation",
    name: "Form Validation",
    meta: { title: "Form Validation", authRequired: true },
    component: () => import("../views/forms/validation"),
  },
  {
    path: "/form/wizard",
    name: "Form Wizard",
    meta: { title: "Form Wizard", authRequired: true },
    component: () => import("../views/forms/wizard"),
  },
  {
    path: "/form/masks",
    name: "form-mask",
    meta: { title: "Form Mask", authRequired: true },
    component: () => import("../views/forms/masks"),
  },
  {
    path: "/form/pickers",
    name: "form-pickers",
    meta: { title: "Form Picker", authRequired: true },
    component: () => import("../views/forms/pickers"),
  },
  {
    path: "/form/range-sliders",
    name: "form-range-slider",
    meta: { title: "Form Range Slider", authRequired: true },
    component: () => import("../views/forms/range-sliders"),
  },
  {
    path: "/form/select",
    name: "form-select",
    meta: { title: "Form Select", authRequired: true },
    component: () => import("../views/forms/select"),
  },
  {
    path: "/form/checkboxs-radios",
    name: "form-checkboxs-radio",
    meta: { title: "Checkboxs & Radios", authRequired: true },
    component: () => import("../views/forms/checkboxs-radios"),
  },
  {
    path: "/landing",
    name: "landing",
    meta: { title: "Landing", authRequired: true },
    component: () => import("../views/landing/index"),
  },
  {
    path: "/nft-landing",
    name: "nft-landing",
    meta: { title: "NFT Landing", authRequired: true },
    component: () => import("../views/landing/nft-landing"),
  },
  {
    path: "/job-landing",
    name: "job-landing",
    meta: { title: "Job Landing", authRequired: true },
    component: () => import("../views/landing/job-landing"),
  },
  {
    path: "/pages/starter",
    name: "starter",
    meta: { title: "Starter", authRequired: true },
    component: () => import("../views/pages/starter"),
  },
  {
    path: "/pages/roles",
    name: "roles",
    meta: { title: "Roles", authRequired: true },
    component: () => import("../views/pages/roles"),
  },
  {
    path: "/pages/faq-management",
    name: "faq-management",
    meta: { title: "FAQ Management", authRequired: true },
    component: () => import("../views/pages/FaqManagement"),
  },
  {
    path: "/admin/role-menu-management",
    name: "role-menu-management",
    meta: { title: "Menu Access", authRequired: true, menuId: "admin.menu-access" },
    component: () => import("../views/admin/RoleMenuManagement"),
  },
  {
    path: "/hwc/counties",
    name: "hwc-counties",
    meta: { title: "HWC Counties", authRequired: true },
    component: () => import("../views/hwc/Counties"),
  },
  {
    path: "/hwc/sub-counties",
    name: "hwc-sub-counties",
    meta: { title: "HWC Sub-Counties", authRequired: true },
    component: () => import("../views/hwc/SubCounties"),
  },
  {
    path: "/hwc/constituencies",
    name: "hwc-constituencies",
    meta: { title: "HWC Constituencies", authRequired: true },
    component: () => import("../views/hwc/Constituencies"),
  },
  {
    path: "/hwc/wards",
    name: "hwc-wards",
    meta: { title: "HWC Wards", authRequired: true },
    component: () => import("../views/hwc/Wards"),
  },
  {
    path: "/hwc/kws-stations",
    name: "hwc-kws-stations",
    meta: { title: "KWS Stations", authRequired: true },
    component: () => import("../views/hwc/KwsStations"),
  },
  {
    path: "/hwc/incidence-types",
    name: "hwc-incidence-types",
    meta: { title: "Incidence Types", authRequired: true },
    component: () => import("../views/hwc/IncidenceTypes"),
  },
  {
    path: "/hwc/conflicts",
    name: "hwc-conflicts",
    meta: { title: "HWC Conflicts", authRequired: true },
    component: () => import("../views/hwc/HwcConflicts"),
  },
  // HWC Reports Routes
  {
    path: "/hwc/reports/interactive-heatmaps",
    name: "hwc-reports-interactive-heatmaps",
    meta: { title: "HWC Interactive Heatmaps", authRequired: true },
    component: () => import("../views/hwc/reports/InteractiveHeatmaps"),
  },
  {
    path: "/hwc/reports/temporal-trends",
    name: "hwc-reports-temporal-trends",
    meta: { title: "HWC Temporal Trends", authRequired: true },
    component: () => import("../views/hwc/reports/TemporalTrends"),
  },
  {
    path: "/hwc/reports/species-analysis",
    name: "hwc-reports-species-analysis",
    meta: { title: "HWC Species Analysis Tools", authRequired: true },
    component: () => import("../views/hwc/reports/SpeciesAnalysis"),
  },
  {
    path: "/hwc/reports/conflict-outcome-tracking",
    name: "hwc-reports-conflict-outcome-tracking",
    meta: { title: "HWC Conflict Outcome Tracking", authRequired: true },
    component: () => import("../views/hwc/reports/ConflictOutcomeTracking"),
  },
  {
    path: "/hwc/reports/multidimensional-analysis",
    name: "hwc-reports-multidimensional-analysis",
    meta: { title: "HWC Multidimensional Analysis", authRequired: true },
    component: () => import("../views/hwc/reports/MultidimensionalAnalysis"),
  },
  {
    path: "/management/animal-census-locations",
    name: "animal-census-locations",
    meta: { title: "Animal Census Locations", authRequired: true },
    component: () => import("../views/management/animal-census-locations"),
  },
  {
    path: "/management/animal-census-survey-seasons",
    name: "animal-census-survey-seasons",
    meta: { title: "Animal Census Survey Seasons", authRequired: true },
    component: () => import("../views/management/animal-census-survey-seasons"),
  },
  {
    path: "/management/animal-census-survey-methods",
    name: "animal-census-survey-methods",
    meta: { title: "Animal Census Survey Methods", authRequired: true },
    component: () => import("../views/management/animal-census-survey-methods"),
  },
  {
    path: "/weather-rainfall",
    name: "weather-rainfall",
    meta: { title: "Weather Rainfall Data", authRequired: true },
    component: () => import("../views/pages/weather-rainfall"),
  },
  {
    path: "/weather-temperature",
    name: "weather-temperature",
    meta: { title: "Weather Temperature Data", authRequired: true },
    component: () => import("../views/pages/weather-temperature"),
  },
  {
    path: "/management/weather-stations",
    name: "weather-stations",
    meta: { title: "Weather Stations Management", authRequired: true },
    component: () => import("../views/management/weather-stations"),
  },
  {
    path: "/weather/temperature/management",
    name: "temperature-management",
    meta: { title: "Temperature Data Management", authRequired: true },
    component: () => import("../views/weather/temperature/TemperatureManagement"),
  },
  {
    path: "/weather/temperature/dashboard",
    name: "temperature-dashboard",
    meta: { title: "Temperature Analytics Dashboard", authRequired: true },
    component: () => import("../views/weather/temperature/TemperatureDashboard"),
  },
  {
    path: "/weather/temperature/reports",
    name: "temperature-reports",
    meta: { title: "Temperature Reports", authRequired: true },
    component: () => import("../views/weather/temperature/TemperatureReports"),
  },
  
  // Individual Weather Report Routes (pointing to existing components)
  {
    path: "/reports/weather/rainfall-summary",
    name: "weather-rainfall-summary",
    meta: { title: "Rainfall Summary Report", authRequired: true },
    component: () => import("../views/weather/temperature/TemperatureDashboard"),
  },
  {
    path: "/reports/weather/temperature-analysis",
    name: "weather-temperature-analysis",
    meta: { title: "Temperature Analysis Report", authRequired: true },
    component: () => import("../views/weather/temperature/TemperatureReports"),
  },
  {
    path: "/reports/weather/data-quality",
    name: "weather-data-quality",
    meta: { title: "Weather Data Quality Report", authRequired: true },
    component: () => import("../views/weather/temperature/TemperatureDashboard"),
  },
  {
    path: "/bushmeat/records",
    name: "bushmeat-records",
    meta: { title: "Bushmeat Records", authRequired: true },
    component: () => import("../views/bushmeat/records"),
  },
  {
    path: "/bushmeat/locations",
    name: "bushmeat-locations",
    meta: { title: "Bushmeat Locations", authRequired: true },
    component: () => import("../views/bushmeat/locations"),
  },
  {
    path: "/bushmeat/species",
    name: "bushmeat-species",
    meta: { title: "Bushmeat Species Impact", authRequired: true },
    component: () => import("../views/bushmeat/species"),
  },
  {
    path: "/bushmeat/analytics",
    name: "bushmeat-analytics", 
    meta: { title: "Bushmeat Analytics", authRequired: true },
    component: () => import("../views/bushmeat/analytics"),
  },
  {
    path: "/bushmeat/dashboard",
    name: "bushmeat-dashboard",
    meta: { title: "Bushmeat Dashboard", authRequired: true },
    component: () => import("../views/bushmeat/BushmeatDashboard"),
  },
  {
    path: "/bushmeat/reports",
    name: "bushmeat-reports",
    meta: { title: "Bushmeat Reports", authRequired: true },
    component: () => import("../views/bushmeat/BushmeatReports"),
  },
  {
    path: "/bushmeat/interventions",
    name: "bushmeat-interventions",
    meta: { title: "Bushmeat Interventions", authRequired: true },
    component: () => import("../views/bushmeat/interventions"),
  },
  
  // Bushmeat Settings/Management Routes
  {
    path: "/bushmeat/settings/hunting-methods",
    name: "bushmeat-hunting-methods",
    meta: { title: "Hunting Methods Management", authRequired: true },
    component: () => import("../views/bushmeat/settings/HuntingMethods"),
  },
  {
    path: "/bushmeat/settings/weapon-types",
    name: "bushmeat-weapon-types", 
    meta: { title: "Weapon Types Management", authRequired: true },
    component: () => import("../views/bushmeat/settings/WeaponTypes"),
  },
  {
    path: "/bushmeat/settings/status-types",
    name: "bushmeat-status-types",
    meta: { title: "Status Types Management", authRequired: true },
    component: () => import("../views/bushmeat/settings/StatusTypes"),
  },
  {
    path: "/bushmeat/settings/hunter-age-ranges",
    name: "bushmeat-hunter-age-ranges", 
    meta: { title: "Hunter Age Ranges Management", authRequired: true },
    component: () => import("../views/bushmeat/settings/HunterAgeRanges"),
  },
  {
    path: "/bushmeat/settings/hunter-occupations",
    name: "bushmeat-hunter-occupations",
    meta: { title: "Hunter Occupations Management", authRequired: true },
    component: () => import("../views/bushmeat/settings/HunterOccupations"),
  },
  // Bushmeat Reports
  {
    path: "/reports/bushmeat/trade-volume-analysis",
    name: "bushmeat-trade-volume-analysis",
    meta: { title: "Bushmeat Trade Volume Analysis", authRequired: true },
    component: () => import("../views/reports/bushmeat/trade-volume-analysis"),
  },
  {
    path: "/reports/bushmeat/species-impact-assessment",
    name: "bushmeat-species-impact-assessment",
    meta: { title: "Bushmeat Species Impact Assessment", authRequired: true },
    component: () => import("../views/reports/bushmeat/species-impact-assessment"),
  },
  {
    path: "/reports/bushmeat/geographic-distribution",
    name: "bushmeat-geographic-distribution",
    meta: { title: "Bushmeat Geographic Distribution Report", authRequired: true },
    component: () => import("../views/reports/bushmeat/geographic-distribution"),
  },
  {
    path: "/reports/bushmeat/seasonal-trends",
    name: "bushmeat-seasonal-trends",
    meta: { title: "Bushmeat Seasonal Trends Analysis", authRequired: true },
    component: () => import("../views/reports/bushmeat/seasonal-trends"),
  },
  {
    path: "/reports/bushmeat/conservation-effectiveness",
    name: "bushmeat-conservation-effectiveness",
    meta: { title: "Bushmeat Conservation Effectiveness Report", authRequired: true },
    component: () => import("../views/reports/bushmeat/conservation-effectiveness"),
  },
  {
    path: "/reports/bushmeat/stakeholder-summary",
    name: "bushmeat-stakeholder-summary",
    meta: { title: "Bushmeat Stakeholder Summary Report", authRequired: true },
    component: () => import("../views/reports/bushmeat/stakeholder-summary"),
  },
  {
    path: "/reports/bushmeat/intervention-impact",
    name: "bushmeat-intervention-impact",
    meta: { title: "Bushmeat Intervention Impact Analysis", authRequired: true },
    component: () => import("../views/reports/bushmeat/intervention-impact"),
  },
  {
    path: "/pages/users",
    name: "users",
    meta: { title: "Users", authRequired: true },
    component: () => import("../views/pages/users"),
  },
  {
    path: "/pages/species",
    name: "species",
    meta: { title: "Species", authRequired: true },
    component: () => import("../views/pages/species"),
  },
  // {
  //   path: "/pages/marinespecies",
  //   name: "marinespecies",
  //   meta: { title: "Marine Species", authRequired: true },
  //   component: () => import("../views/pages/MarineSpecies"),
  // },
  {
    path: "/pages/ecosystems",
    name: "ecosystems",
    meta: { title: "Ecosystems", authRequired: true },
    component: () => import("../views/pages/ecosystems"),
  },
  // {
  //   path: "/pages/marineEcosystems",
  //   name: "marineecosystems",
  //   meta: { title: "Marine Ecosystems", authRequired: true },
  //   component: () => import("../views/pages/MarineEcoSystems"),
  // },
  {
    path: "/pages/parkconservancy",
    name: "parkconservancy",
    meta: { title: "Park/Conservancy", authRequired: true },
    component: () => import("../views/pages/ParkConservancy"),
  },
  {
    path: "/pages/conservancies",
    name: "conservancies",
    meta: { title: "Kenya Conservancies", authRequired: true },
    component: () => import("../views/pages/Conservancies"),
  },
  {
    path: "/pages/wildlifecorridors",
    name: "wildlifecorridors",
    meta: { title: "Wildlife Corridors", authRequired: true },
    component: () => import("../views/pages/WildlifeCorridors"),
  },
  {
    path: "/pages/iucn",
    name: "iucn",
    meta: { title: "IUCN Species", authRequired: true },
    component: () => import("../views/pages/iucn"),
  },
  {
    path: "/pages/iucn-kingdoms",
    name: "iucn-kingdoms",
    meta: { title: "IUCN Kingdoms", authRequired: true },
    component: () => import("../views/pages/iucn-kingdoms"),
  },
  {
    path: "/pages/iucn-phylums",
    name: "iucn-phylums",
    meta: { title: "IUCN Phylums", authRequired: true },
    component: () => import("../views/pages/iucn-phylums"),
  },
  {
    path: "/pages/iucn-classes",
    name: "iucn-classes",
    meta: { title: "IUCN Classes", authRequired: true },
    component: () => import("../views/pages/iucn-classes"),
  },
  {
    path: "/pages/iucn-orders",
    name: "iucn-orders",
    meta: { title: "IUCN Orders", authRequired: true },
    component: () => import("../views/pages/iucn-orders"),
  },
  {
    path: "/pages/iucn-families",
    name: "iucn-families",
    meta: { title: "IUCN Families", authRequired: true },
    component: () => import("../views/pages/iucn-families"),
  },
  {
    path: "/pages/iucn-genera",
    name: "iucn-genera",
    meta: { title: "IUCN Genera", authRequired: true },
    component: () => import("../views/pages/iucn-genera"),
  },
  {
    path: "/pages/threatanalysis",
    name: "threatanalysis",
    meta: { title: "Threat Analysis", authRequired: true },
    component: () => import("../views/pages/ThreatAnalysis"),
  },
  {
    path: "/pages/conservationproject",
    name: "conservationproject",
    meta: { title: "Conservation Projects", authRequired: true },
    component: () => import("../views/pages/ConservationProject"),
  },
  {
    path: "/pages/publications",
    name: "publications",
    meta: { title: "Publications", authRequired: true },
    component: () => import("../views/pages/Publications"),
  },
  {
    path: "/pages/educationalmaterial",
    name: "educationalmaterial",
    meta: { title: "Educational Material", authRequired: true },
    component: () => import("../views/pages/EducationalMaterial"),
  },
  {
    path: "/pages/climatedata",
    name: "climatedata",
    meta: { title: "Climate Data", authRequired: true },
    component: () => import("../views/pages/ClimateData"),
  },
  // {
  //   path: "/pages/waterqualitydata",
  //   name: "waterqualitydata",
  //   meta: { title: "Water Quality Data", authRequired: true },
  //   component: () => import("../views/pages/WaterQualityData"),
  // },
  {
    path: "/pages/stakeholders",
    name: "stakeholders",
    meta: { title: "Stakeholders", authRequired: true },
    component: () => import("../views/pages/Stakeholders"),
  },
  {
    path: "/pages/profile",
    name: "profile",
    meta: { title: "Profile", authRequired: true },
    component: () => import("../views/pages/profile/simple"),
  },
  {
    path: "/pages/profile-setting",
    name: "profile-setting",
    meta: { title: "Setting", authRequired: true },
    component: () => import("../views/pages/profile/setting"),
  },
  {
    path: "/pages/maintenance",
    name: "maintenance",
    meta: { title: "Maintanance", authRequired: true },
    component: () => import("../views/pages/maintenance"),
  },
  {
    path: "/pages/coming-soon",
    name: "coming-soon",
    meta: { title: "Comming Soon", authRequired: true },
    component: () => import("../views/pages/coming-soon"),
  },
  {
    path: "/pages/timeline",
    name: "timeline",
    meta: { title: "Timeline", authRequired: true },
    component: () => import("../views/pages/timeline"),
  },
  {
    path: "/pages/faqs",
    name: "FAQs",
    meta: { title: "FAQs", authRequired: true },
    component: () => import("../views/pages/faqs"),
  },
  {
    path: "/pages/pricing",
    name: "pricing",
    meta: { title: "Pricing", authRequired: true },
    component: () => import("../views/pages/pricing"),
  },
  {
    path: "/pages/team",
    name: "team",
    meta: { title: "Team", authRequired: true },
    component: () => import("../views/pages/team"),
  },
  {
    path: "/pages/search-results",
    name: "search-results",
    meta: { title: "Search Results", authRequired: true },
    component: () => import("../views/pages/search-results"),
  },
  {
    path: "/pages/sitemap",
    name: "sitemap",
    meta: { title: "Sitemap", authRequired: true },
    component: () => import("../views/pages/sitemap"),
  },
  {
    path: "/pages/privacy-policy",
    name: "privacy-policy",
    meta: { title: "Privacy Policy", authRequired: true },
    component: () => import("../views/pages/privacy-policy"),
  },
  {
    path: "/pages/term-conditions",
    name: "term-conditions",
    meta: { title: "Term Conditions", authRequired: true },
    component: () => import("../views/pages/term-conditions"),
  },
  {
    path: "/blogs/list-view",
    name: "List View",
    meta: { title: "Blogs", authRequired: true },
    component: () => import("../views/pages/blogs/list-view"),
  },
  {
    path: "/blogs/grid-view",
    name: "grid-view",
    meta: { title: "Blogs", authRequired: true },
    component: () => import("../views/pages/blogs/grid-view"),
  },
  {
    path: "/blogs/overview",
    name: "overview",
    meta: { title: "Blogs", authRequired: true },
    component: () => import("../views/pages/blogs/overview"),
  },
  {
    path: "/charts/chartjs",
    name: "chartjs-chart",
    meta: { title: "Chartjs", authRequired: true },
    component: () => import("../views/charts/chartjs/index"),
  },
  {
    path: "/charts/echart",
    name: "echart",
    meta: { title: "Echarts", authRequired: true },
    component: () => import("../views/charts/echart/index"),
  },
  {
    path: '/charts/apex-line',
    name: 'line',
    meta: {
      title: "Line Charts", authRequired: true,
    },
    component: () => import('../views/charts/apex/line/index')
  },
  {
    path: '/charts/apex-area',
    name: 'area-chart',
    meta: {
      title: "Area Charts", authRequired: true,
    },
    component: () => import('../views/charts/apex/area/index')
  },
  {
    path: '/charts/apex-bar',
    name: 'bar-chart',
    meta: {
      title: "Bar Charts", authRequired: true,
    },
    component: () => import('../views/charts/apex/bar/index')
  },
  {
    path: '/charts/apex-column',
    name: 'column-chart',
    meta: {
      title: "Column Charts", authRequired: true,
    },
    component: () => import('../views/charts/apex/column/index')
  },

  {
    path: '/charts/apex-mixed',
    name: 'mixed-chart',
    meta: {
      title: "Mixed Charts", authRequired: true,
    },
    component: () => import('../views/charts/apex/mixed/index')
  },
  {
    path: '/charts/apex-range-area',
    name: 'range-area-chart',
    meta: {
      title: "Range Area Charts", authRequired: true,
    },
    component: () => import('../views/charts/apex/rangearea/index')
  },
  {
    path: '/charts/apex-funnel',
    name: 'funnel-chart',
    meta: {
      title: "Funnel Charts", authRequired: true,
    },
    component: () => import('../views/charts/apex/funnel/index')
  },
  {
    path: '/charts/apex-candlestick',
    name: 'candlestick',
    meta: {
      title: "Candlestick", authRequired: true,
    },
    component: () => import('../views/charts/apex/candlestick/index')
  },
  {
    path: '/charts/apex-boxplot',
    name: 'boxplot',
    meta: {
      title: "Boxplot", authRequired: true,
    },
    component: () => import('../views/charts/apex/boxplot/index')
  },
  {
    path: '/charts/apex-bubble',
    name: 'bubble',
    meta: {
      title: "Bubble Chart", authRequired: true,
    },
    component: () => import('../views/charts/apex/bubble/index')
  },
  {
    path: '/charts/apex-scatter',
    name: 'scatter',
    meta: {
      title: "Scatter", authRequired: true,
    },
    component: () => import('../views/charts/apex/scatter/index')
  },
  {
    path: '/charts/apex-heatmap',
    name: 'heatmap',
    meta: {
      title: "Heatmap", authRequired: true,
    },
    component: () => import('../views/charts/apex/heatmap/index')
  },
  {
    path: '/charts/apex-treemap',
    name: 'treemap',
    meta: {
      title: "Treemap", authRequired: true,
    },
    component: () => import('../views/charts/apex/treemap/index')
  },
  {
    path: '/charts/apex-pie',
    name: 'pie',
    meta: {
      title: "Apex Pie", authRequired: true,
    },
    component: () => import('../views/charts/apex/pie/index')
  },
  {
    path: '/charts/apex-radialbar',
    name: 'radialbar',
    meta: {
      title: "Apex Radialbar", authRequired: true,
    },
    component: () => import('../views/charts/apex/radiabar/index')
  },
  {
    path: '/charts/apex-radar',
    name: 'radar',
    meta: {
      title: "Apex Radar", authRequired: true,
    },
    component: () => import('../views/charts/apex/radar/index')
  },
  {
    path: '/charts/apex-polararea',
    name: 'polararea',
    meta: {
      title: "Polararea", authRequired: true,
    },
    component: () => import('../views/charts/apex/polararea/index')
  },
  {
    path: '/charts/apex-slope',
    name: 'slope',
    meta: {
      title: "Slope", authRequired: true,
    },
    component: () => import('../views/charts/apex/slope/index')
  },
  {
    path: '/advance-ui/animation',
    name: 'animation',
    meta: {
      title: "Animation", authRequired: true,
    },
    component: () => import('../views/advance-ui/animation')
  },
  {
    path: '/advance-ui/highlight',
    name: 'highlight',
    meta: {
      title: "Highlight", authRequired: true,
    },
    component: () => import('../views/advance-ui/highlight')
  },
  {
    path: '/advance-ui/scrollbar',
    name: 'scrollbar',
    meta: {
      title: "Scrollbar", authRequired: true,
    },
    component: () => import('../views/advance-ui/scrollbar')
  },
  {
    path: '/advance-ui/scrollspy',
    name: 'scrollspy',
    meta: {
      title: "Scrollspy", authRequired: true,
    },
    component: () => import('../views/advance-ui/scrollspy')
  },
  {
    path: '/advance-ui/sweetalerts',
    name: 'sweetalerts',
    meta: {
      title: "Sweet Alerts", authRequired: true,
    },
    component: () => import('../views/advance-ui/sweetalerts')
  },
  {
    path: '/advance-ui/swiper',
    name: 'Swiper Slider',
    meta: {
      title: "Swiper", authRequired: true,
    },
    component: () => import('../views/advance-ui/swiper')
  },
  {
    path: '/auth/signin-basic',
    name: 'signin-basic',
    meta: {
      title: "Signin Basic", authRequired: true,
    },
    component: () => import('../views/auth/signin/basic')
  },
  {
    path: '/auth/signin-cover',
    name: 'signin-cover',
    meta: {
      title: "Signin Cover", authRequired: true,
    },
    component: () => import('../views/auth/signin/cover')
  },
  {
    path: '/auth/signup-basic',
    name: 'signup-basic',
    meta: {
      title: "Signup Basic", authRequired: true,
    },
    component: () => import('../views/auth/signup/basic')
  },
  {
    path: '/auth/signup-cover',
    name: 'signup-cover',
    meta: {
      title: "Signup Cover", authRequired: true,
    },
    component: () => import('../views/auth/signup/cover')
  },
  {
    path: '/auth/reset-pwd-basic',
    name: 'reset-pwd-basic',
    meta: {
      title: "Reset Password", authRequired: true,
    },
    component: () => import('../views/auth/reset/basic')
  },
  {
    path: '/auth/reset-pwd-cover',
    name: 'reset-pwd-cover',
    meta: {
      title: "Reset Password", authRequired: true,
    },
    component: () => import('../views/auth/reset/cover')
  },
  {
    path: '/auth/create-pwd-basic',
    name: 'create-pwd-basic',
    meta: {
      title: "create Password", authRequired: true,
    },
    component: () => import('../views/auth/create/basic')
  },
  {
    path: '/auth/create-pwd-cover',
    name: 'create-pwd-cover',
    meta: {
      title: "create Password", authRequired: true,
    },
    component: () => import('../views/auth/create/cover')
  },
  {
    path: '/auth/lockscreen-basic',
    name: 'lock-screen-basic',
    meta: {
      title: "Lock Screen", authRequired: true,
    },
    component: () => import('../views/auth/lockscreen/basic')
  },
  {
    path: '/auth/lockscreen-cover',
    name: 'lock-screen-cover',
    meta: {
      title: "Lock Screen", authRequired: true,
    },
    component: () => import('../views/auth/lockscreen/cover')
  },
  {
    path: '/auth/twostep-basic',
    name: 'twostep-basic',
    meta: {
      title: "Two Step Auth", authRequired: true,
    },
    component: () => import('../views/auth/twostep/basic')
  }, {
    path: '/auth/twostep-cover',
    name: 'twostep-cover',
    meta: {
      title: "Two Step Auth", authRequired: true,
    },
    component: () => import('../views/auth/twostep/cover')
  },
  {
    path: '/auth/404',
    name: '404',
    meta: {
      title: "Error 404", authRequired: true,
    },
    component: () => import('../views/auth/errors/404')
  },
  {
    path: '/auth/500',
    name: '500',
    meta: {
      title: "Error 500", authRequired: true,
    },
    component: () => import('../views/auth/errors/500')
  },
  {
    path: '/auth/404-basic',
    name: '404-basic',
    meta: {
      title: "Error 404", authRequired: true,
    },
    component: () => import('../views/auth/errors/404-basic')
  },
  {
    path: '/auth/404-cover',
    name: '404-cover',
    meta: {
      title: "Error 404", authRequired: true,
    },
    component: () => import('../views/auth/errors/404-cover')
  },
  {
    path: '/auth/ofline',
    name: 'ofline',
    meta: {
      title: "Offline", authRequired: true,
    },
    component: () => import('../views/auth/errors/ofline')
  },
  {
    path: '/auth/logout-basic',
    name: 'logout-basic',
    meta: {
      title: "Logout", authRequired: true,
    },
    component: () => import('../views/auth/logout/basic')
  },
  {
    path: '/auth/logout-cover',
    name: 'logout-cover',
    meta: {
      title: "Logout", authRequired: true,
    },
    component: () => import('../views/auth/logout/cover')
  },
  {
    path: '/auth/success-msg-basic',
    name: 'success-msg-basic',
    meta: {
      title: "Success Message", authRequired: true,
    },
    component: () => import('../views/auth/success-msg/basic')
  },
  {
    path: '/auth/success-msg-cover',
    name: 'success-msg-cover',
    meta: {
      title: "Success Message", authRequired: true,
    },
    component: () => import('../views/auth/success-msg/cover')
  },
  {
    path: "/maps/google",
    name: "Google Maps",
    meta: {
      title: "Google Maps", authRequired: true,
    },
    component: () => import("../views/maps/google"),
  },
  {
    path: "/maps/leaflet",
    name: "Leaflet Maps",
    meta: { title: "Leaflet Maps", authRequired: true },
    component: () => import("../views/maps/leaflet/index"),
  },
  
  // National Datasets Routes
  {
    path: "/national-datasets",
    name: "national-datasets",
    meta: { title: "National Datasets", authRequired: true },
    component: () => import("../views/national-datasets/index"),
  },
  {
    path: "/national-datasets/land-statistics",
    name: "national-datasets-land-statistics",
    meta: { title: "Land Statistics", authRequired: true },
    component: () => import("../views/national-datasets/land-statistics-enhanced"),
  },
  {
    path: "/national-datasets/protected-areas",
    name: "national-datasets-protected-areas",
    meta: { title: "Protected Areas", authRequired: true },
    component: () => import("../views/national-datasets/protected-areas-enhanced"),
  },
  {
    path: "/national-datasets/conservancies",
    name: "national-datasets-conservancies",
    meta: { title: "Conservancies", authRequired: true },
    component: () => import("../views/national-datasets/conservancies"),
  },
  {
    path: "/national-datasets/census",
    name: "national-datasets-census",
    meta: { title: "Wildlife Census", authRequired: true },
    component: () => import("../views/national-datasets/census-enhanced"),
  },
  {
    path: "/national-datasets/species-status",
    name: "national-datasets-species-status",
    meta: { title: "Species Conservation Status", authRequired: true },
    component: () => import("../views/national-datasets/species-status"),
  },
  {
    path: "/national-datasets/visualization-dashboard",
    name: "national-datasets-visualization-dashboard", 
    meta: { title: "Data Visualization Dashboard", authRequired: true },
    component: () => import("../views/national-datasets/visualization-dashboard"),
  },
  {
    path: "/national-datasets/overview-summary-form",
    name: "national-datasets-overview-summary-form",
    meta: { title: "Overview Summary Form", authRequired: true },
    component: () => import("../views/national-datasets/overview-summary-form"),
  },
  {
    path: "/national-datasets/land-statistics-form",
    name: "national-datasets-land-statistics-form",
    meta: { title: "Land Statistics Form", authRequired: true },
    component: () => import("../views/national-datasets/land-statistics-form"),
  },
  
  // Ecosystem Statistics Routes
  {
    path: "/national-datasets/ecosystem-stats/coastal-marine",
    name: "national-datasets-coastal-marine-ecosystem-form",
    meta: { title: "Coastal Marine Ecosystem Statistics", authRequired: true },
    component: () => import("../views/national-datasets/coastal-marine-ecosystem-form"),
  },
  {
    path: "/national-datasets/ecosystem-stats/forest",
    name: "national-datasets-forest-ecosystem-form",
    meta: { title: "Forest Ecosystem Statistics", authRequired: true },
    component: () => import("../views/national-datasets/forest-ecosystem-form"),
  },
  {
    path: "/national-datasets/ecosystem-stats/savannah",
    name: "national-datasets-savannah-ecosystem-form",
    meta: { title: "Savannah Ecosystem Statistics", authRequired: true },
    component: () => import("../views/national-datasets/savannah-ecosystem-form"),
  },
  {
    path: "/national-datasets/ecosystem-stats/wetlands",
    name: "national-datasets-wetlands-ecosystem-form",
    meta: { title: "Wetlands Ecosystem Statistics", authRequired: true },
    component: () => import("../views/national-datasets/wetlands-ecosystem-form"),
  },
  {
    path: "/national-datasets/analytics",
    name: "national-datasets-analytics",
    meta: { title: "National Datasets Analytics", authRequired: true },
    component: () => import("../views/national-datasets/analytics-dashboard"),
  },
  {
    path: "/national-datasets/executive-overview",
    name: "national-datasets-executive-overview",
    meta: { title: "Conservation Executive Overview", authRequired: true },
    component: () => import("../views/national-datasets/executive-conservation-overview"),
  },
  {
    path: "/national-datasets/executive-protected-areas",
    name: "national-datasets-executive-protected-areas", 
    meta: { title: "Protected Areas Executive Summary", authRequired: true },
    component: () => import("../views/national-datasets/executive-protected-areas"),
  },
  {
    path: "/national-datasets/executive-species-census",
    name: "national-datasets-executive-species-census",
    meta: { title: "Species Census Executive Summary", authRequired: true },
    component: () => import("../views/national-datasets/executive-species-census"),
  },
  {
    path: "/national-datasets/executive-land-statistics", 
    name: "national-datasets-executive-land-statistics",
    meta: { title: "Land Statistics Executive Summary", authRequired: true },
    component: () => import("../views/national-datasets/executive-land-statistics"),
  },
  
  {
    path: "/search",
    name: "search",
    meta: { title: "Advanced Search", authRequired: true },
    component: () => import("../views/search/index"),
  },
  {
    path: "/notifications",
    name: "notifications",
    meta: { title: "Notifications", authRequired: true },
    component: () => import("../views/notifications/NotificationsPage"),
  },
  {
    path: "/reports",
    name: "reports",
    meta: { title: "Reports & Exports", authRequired: true },
    component: () => import("../views/reports/ReportDashboard"),
  },
  // New menu item routes
  {
    path: "/kwca-data",
    name: "kwca-data",
    meta: { title: "KWCA Data Management", authRequired: true },
    component: () => import("../views/pages/KwcaData"),
  },
  {
    path: "/iucn-taxonomy",
    name: "iucn-taxonomy",
    meta: { title: "IUCN Taxonomy Hierarchy", authRequired: true },
    component: () => import("../views/pages/IucnTaxonomy"),
  },
  {
    path: "/translocations",
    name: "translocations",
    meta: { title: "Wildlife Translocations", authRequired: true },
    component: () => import("../views/pages/WildlifeTranslocations"),
  },
  {
    path: "/translocations/reports",
    name: "translocations-reports",
    meta: { title: "Translocations Reports", authRequired: true },
    component: () => import("../views/translocations/TranslocationsReports"),
  },
  
  // Individual Translocations Report Routes
  {
    path: "/translocations/reports/summary",
    name: "translocations-reports-summary",
    meta: { title: "Quick Summary Report", authRequired: true },
    component: () => import("../views/translocations/TranslocationsReports"),
  },
  {
    path: "/translocations/reports/species-trends",
    name: "translocations-reports-species-trends",
    meta: { title: "Species Trends Analysis", authRequired: true },
    component: () => import("../views/translocations/TranslocationsReports"),
  },
  {
    path: "/translocations/reports/conservation-impact",
    name: "translocations-reports-conservation-impact",
    meta: { title: "Conservation Impact Assessment", authRequired: true },
    component: () => import("../views/translocations/TranslocationsReports"),
  },
  {
    path: "/translocations/reports/success-analysis",
    name: "translocations-reports-success-analysis",
    meta: { title: "Success Analysis", authRequired: true },
    component: () => import("../views/translocations/TranslocationsReports"),
  },
  {
    path: "/translocations/reports/temporal-analysis",
    name: "translocations-reports-temporal-analysis",
    meta: { title: "Temporal Analysis", authRequired: true },
    component: () => import("../views/translocations/TranslocationsReports"),
  },
  {
    path: "/translocations/reports/custom",
    name: "translocations-reports-custom",
    meta: { title: "Custom Report Builder", authRequired: true },
    component: () => import("../views/translocations/TranslocationsReports"),
  },
  {
    path: "/disease-outbreaks",
    name: "disease-outbreaks",
    meta: { title: "Disease Outbreaks", authRequired: true },
    component: () => import("../views/pages/DiseaseOutbreaks"),
  },
  
  // Animal Health Management Routes
  {
    path: "/animal-health/dashboard",
    name: "animal-health-dashboard",
    meta: { title: "Executive Health Dashboard", authRequired: true },
    component: () => import("../views/animal-health/AdvancedAnalytics"),
  },
  {
    path: "/dashboard/animal-health-executive",
    name: "animal-health-executive-dashboard",
    meta: { title: "Animal Health Executive Dashboard", authRequired: true },
    component: () => import("../views/dashboard/animal-health-executive-dashboard"),
  },
  {
    path: "/dashboard/hwc-executive",
    name: "hwc-executive-dashboard",
    meta: { title: "HWC Executive Dashboard", authRequired: true },
    component: () => import("../views/dashboard/HwcExecutiveDashboard"),
  },
  {
    path: "/animal-health/records",
    name: "animal-health-records",
    meta: { title: "Animal Health Records", authRequired: true },
    component: () => import("../views/animal-health/Records"),
  },
  {
    path: "/animal-health/records/create",
    name: "animal-health-records-create",
    meta: { title: "Create Health Record", authRequired: true },
    component: () => import("../views/animal-health/CreateRecord"),
  },
  {
    path: "/animal-health/records/:id",
    name: "animal-health-records-detail",
    meta: { title: "Health Record Details", authRequired: true },
    component: () => import("../views/animal-health/RecordDetail"),
    props: true
  },
  {
    path: "/animal-health/records/:id/edit",
    name: "animal-health-records-edit",
    meta: { title: "Edit Health Record", authRequired: true },
    component: () => import("../views/animal-health/EditRecord"),
    props: true
  },
  {
    path: "/animal-health/conditions",
    name: "animal-health-conditions",
    meta: { title: "Health Conditions", authRequired: true },
    component: () => import("../views/animal-health/HealthConditionsView"),
  },
  {
    path: "/animal-health/pathogens",
    name: "animal-health-pathogens",
    meta: { title: "Pathogens", authRequired: true },
    component: () => import("../views/animal-health/PathogensView"),
  },
  {
    path: "/animal-health/treatments",
    name: "animal-health-treatments",
    meta: { title: "Treatments", authRequired: true },
    component: () => import("../views/animal-health/TreatmentsView"),
  },
  {
    path: "/animal-health/diagnosis-methods",
    name: "animal-health-diagnosis-methods",
    meta: { title: "Diagnosis Methods", authRequired: true },
    component: () => import("../views/animal-health/DiagnosisMethodsView"),
  },
  {
    path: "/animal-health/reports",
    name: "animal-health-reports",
    meta: { title: "Animal Health Reports", authRequired: true },
    component: () => import("../views/animal-health/AnimalHealthReportsView"),
  },
  {
    path: "/animal-health/analytics",
    name: "animal-health-analytics",
    meta: { title: "Advanced Analytics", authRequired: true },
    component: () => import("../views/animal-health/AdvancedAnalytics"),
  },
  {
    path: "/reports/animal-health/alerts-dashboard",
    name: "animal-health-alerts-dashboard",
    meta: { title: "Health Alerts Dashboard", authRequired: true },
    component: () => import("../components/animal-health/alerts/AlertsDashboard"),
  },
  {
    path: "/reports/animal-health/monthly-summary",
    name: "animal-health-monthly-summary",
    meta: { title: "Monthly Health Summary", authRequired: true },
    component: () => import("../views/reports/animal-health/MonthlySummaryReport"),
  },
  {
    path: "/reports/animal-health/species-health",
    name: "animal-health-species-health",
    meta: { title: "Species Health Analysis", authRequired: true },
    component: () => import("../views/reports/animal-health/SpeciesHealthReport"),
  },
  {
    path: "/reports/animal-health/treatment-outcomes",
    name: "animal-health-treatment-outcomes",
    meta: { title: "Treatment Outcomes Report", authRequired: true },
    component: () => import("../views/reports/animal-health/TreatmentOutcomesReport"),
  },
  {
    path: "/reports/animal-health/outbreak-investigation",
    name: "animal-health-outbreak-investigation",
    meta: { title: "Outbreak Investigation Report", authRequired: true },
    component: () => import("../views/reports/animal-health/OutbreakInvestigationReport"),
  },
  {
    path: "/reports/animal-health/pathogen-surveillance",
    name: "animal-health-pathogen-surveillance",
    meta: { title: "Pathogen Surveillance Report", authRequired: true },
    component: () => import("../views/reports/animal-health/PathogenSurveillanceReport"),
  },
  {
    path: "/reports/animal-health/annual-assessment",
    name: "animal-health-annual-assessment",
    meta: { title: "Annual Health Assessment", authRequired: true },
    component: () => import("../views/reports/animal-health/AnnualAssessmentReport"),
  },

  // Invasive Plants Management Routes
  {
    path: "/invasive-plants/overview",
    name: "invasive-plants-overview",
    meta: { title: "Invasive Plants Overview", authRequired: true },
    component: () => import("../views/invasive-plants/overview"),
  },
  {
    path: "/invasive-plants/species",
    name: "invasive-plants-species",
    meta: { title: "Species Management", authRequired: true },
    component: () => import("../views/invasive-plants/species"),
  },
  {
    path: "/invasive-plants/records",
    name: "invasive-plants-records",
    meta: { title: "Location Records", authRequired: true },
    component: () => import("../views/invasive-plants/records"),
  },
  {
    path: "/invasive-plants/records/create",
    name: "invasive-plants-records-create",
    meta: { title: "Create Invasive Plant Record", authRequired: true },
    component: () => import("../views/invasive-plants/create-record"),
  },
  {
    path: "/invasive-plants/records/:id",
    name: "invasive-plants-records-detail",
    meta: { title: "Record Details", authRequired: true },
    component: () => import("../views/invasive-plants/record-detail"),
    props: true
  },
  {
    path: "/invasive-plants/records/:id/edit",
    name: "invasive-plants-records-edit",
    meta: { title: "Edit Record", authRequired: true },
    component: () => import("../views/invasive-plants/edit-record"),
    props: true
  },
  {
    path: "/invasive-plants/interventions",
    name: "invasive-plants-interventions",
    meta: { title: "Interventions", authRequired: true },
    component: () => import("../views/invasive-plants/interventions"),
  },
  {
    path: "/invasive-plants/analytics",
    name: "invasive-plants-analytics",
    meta: { title: "Analytics", authRequired: true },
    component: () => import("../views/invasive-plants/analytics"),
  },
  {
    path: "/invasive-plants/reports",
    name: "invasive-plants-reports",
    meta: { title: "Reports", authRequired: true },
    component: () => import("../views/invasive-plants/reports"),
  },
  {
    path: "/invasive-plants/import",
    name: "invasive-plants-import",
    meta: { title: "Data Import", authRequired: true },
    component: () => import("../views/invasive-plants/import"),
  },

  // NEW: Invasive Species Analysis & Reports Routes (Enhanced System)
  {
    path: "/dashboard/invasive-species",
    name: "invasive-species-dashboard",
    meta: { title: "Invasive Species Dashboard", authRequired: true },
    component: () => import("../views/dashboard/InvasiveSpeciesDashboard"),
  },
  {
    path: "/invasive-species/reports",
    name: "invasive-species-reports",
    meta: { title: "Invasive Species Reports", authRequired: true },
    component: () => import("../views/invasive-species/Reports"),
  },
  {
    path: "/invasive-species/county-analysis",
    name: "invasive-species-county-analysis",
    meta: { title: "County Analysis - Invasive Species", authRequired: true },
    component: () => import("../views/invasive-species/CountyAnalysis"),
  },
  {
    path: "/invasive-species/habitat-analysis",
    name: "invasive-species-habitat-analysis",
    meta: { title: "Habitat Analysis - Invasive Species", authRequired: true },
    component: () => import("../views/invasive-species/HabitatAnalysis"),
  },
  
  // Invasive Plants Reports
  {
    path: "/reports/invasive-plants/species-distribution",
    name: "invasive-plants-species-distribution",
    meta: { title: "Species Distribution Report", authRequired: true },
    component: () => import("../views/reports/invasive-plants/species-distribution"),
  },
  {
    path: "/reports/invasive-plants/ecosystem-impact",
    name: "invasive-plants-ecosystem-impact",
    meta: { title: "Ecosystem Impact Assessment", authRequired: true },
    component: () => import("../views/reports/invasive-plants/ecosystem-impact"),
  },
  {
    path: "/reports/invasive-plants/intervention-effectiveness",
    name: "invasive-plants-intervention-effectiveness",
    meta: { title: "Intervention Effectiveness Report", authRequired: true },
    component: () => import("../views/reports/invasive-plants/intervention-effectiveness"),
  },
  {
    path: "/reports/invasive-plants/economic-impact",
    name: "invasive-plants-economic-impact",
    meta: { title: "Economic Impact Summary", authRequired: true },
    component: () => import("../views/reports/invasive-plants/economic-impact"),
  },
  {
    path: "/reports/invasive-plants/management-priority",
    name: "invasive-plants-management-priority",
    meta: { title: "Management Priority Report", authRequired: true },
    component: () => import("../views/reports/invasive-plants/management-priority"),
  },

  {
    path: "/conflict-incidents",
    name: "conflict-incidents",
    meta: { title: "Human-Wildlife Conflict", authRequired: true },
    component: () => import("../views/pages/ConflictIncidents"),
  },
  {
    path: "/census-counts",
    name: "census-counts",
    meta: { title: "Wildlife Census & Counts", authRequired: true },
    component: () => import("../views/pages/CensusCounts"),
  },
  {
    path: "/census-counts/edit/:id",
    name: "census-edit",
    meta: { title: "Edit Census Record", authRequired: true },
    component: () => import("../views/pages/CensusEdit"),
  },
  {
    path: "/census-counts/add",
    name: "census-add",
    meta: { title: "Add New Census Record", authRequired: true },
    component: () => import("../views/pages/CensusAdd"),
  },
  {
    path: "/cites-economy",
    name: "cites-economy",
    meta: { title: "CITES Wildlife Economy", authRequired: true },
    component: () => import("../views/pages/CitesEconomy"),
  },
  {
    path: "/data-sharing",
    name: "data-sharing",
    meta: { title: "Data Sharing Management", authRequired: true },
    component: () => import("../views/pages/DataSharing"),
  },
  {
    path: "/admin/data-sharing-submissions",
    name: "data-sharing-submissions",
    meta: { title: "Data Sharing Submissions", authRequired: true },
    component: () => import("../views/pages/DataSharingSubmissions"),
  },
  {
    path: "/admin/data-requests",
    name: "data-requests",
    meta: { title: "Data Access Requests", authRequired: true },
    component: () => import("../views/pages/DataRequests"),
  },
  {
    path: "/admin/conservation-areas",
    name: "conservation-areas",
    meta: { title: "Conservation Areas Management", authRequired: true },
    component: () => import("../views/pages/ConservationAreas"),
  },
  {
    path: "/surveillance",
    name: "surveillance",
    meta: { title: "Wildlife Health Surveillance", authRequired: true },
    component: () => import("../views/pages/WildlifeSurveillance"),
  },
  {
    path: "/genetic-diversity",
    name: "genetic-diversity",
    meta: { title: "Genetic Diversity", authRequired: true },
    component: () => import("../views/pages/GeneticDiversity"),
  },
  {
    path: "/habitat-monitoring",
    name: "habitat-monitoring",
    meta: { title: "Habitat Monitoring", authRequired: true },
    component: () => import("../views/pages/HabitatMonitoring"),
  },
  {
    path: "/migration-corridors",
    name: "migration-corridors",
    meta: { title: "Migration Corridors", authRequired: true },
    component: () => import("../views/pages/MigrationCorridors"),
  },
  {
    path: "/ongoing-research",
    name: "ongoing-research",
    meta: { title: "Ongoing Research Projects", authRequired: true },
    component: () => import("../views/pages/OngoingResearch"),
  },
  {
    path: "/ongoing-research/dashboard",
    name: "ongoing-research-dashboard",
    meta: { title: "Research Analytics Dashboard", authRequired: true },
    component: () => import("../views/pages/OngoingResearchDashboard"),
  },
  {
    path: "/research-publications",
    name: "research-publications",
    meta: { title: "Research Publications", authRequired: true },
    component: () => import("../views/pages/ResearchPublications"),
  },
  {
    path: "/virtual-museums",
    name: "virtual-museums",
    meta: { title: "Virtual Museums", authRequired: true },
    component: () => import("../views/pages/VirtualMuseums"),
  },
  {
    path: "/species-checklist",
    name: "species-checklist",
    meta: { title: "Species Checklist", authRequired: true },
    component: () => import("../views/species-checklist/SpeciesChecklistList"),
  },
  {
    path: "/species-checklist/dashboard",
    name: "species-checklist-dashboard",
    meta: { title: "Species Checklist Dashboard", authRequired: true },
    component: () => import("../views/species-checklist/SpeciesChecklistDashboard"),
  },
  
  // Animal Census Management Routes
  {
    path: "/animal-census/categories",
    name: "animal-census-categories",
    meta: { title: "Animal Census Categories", authRequired: true },
    component: () => import("../views/animal-census/categories"),
  },
  {
    path: "/animal-census/count-areas",
    name: "animal-census-count-areas",
    meta: { title: "Animal Census Count Areas", authRequired: true },
    component: () => import("../views/animal-census/count-areas"),
  },

  // Spatial Analytics Routes (Census Shapefile Data)
  {
    path: "/census/animal-dispersal",
    name: "census-animal-dispersal",
    meta: { title: "Animal Dispersal Areas", authRequired: true },
    component: () => import("../views/census/spatial-analytics/AnimalDispersalView"),
  },
  {
    path: "/census/threat-analysis",
    name: "census-threat-analysis",
    meta: { title: "Threat Analysis Dashboard", authRequired: true },
    component: () => import("../views/census/spatial-analytics/ThreatAnalysisDashboard"),
  },
  {
    path: "/census/kenya-conservancies",
    name: "census-kenya-conservancies",
    meta: { title: "Kenya Conservancies", authRequired: true },
    component: () => import("../views/census/spatial-analytics/KenyaConservanciesView"),
  },
  {
    path: "/census/protected-areas",
    name: "census-protected-areas",
    meta: { title: "Protected Areas", authRequired: true },
    component: () => import("../views/census/spatial-analytics/ProtectedAreasView"),
  },
  {
    path: "/census/species-distribution-maps",
    name: "census-species-distribution-maps",
    meta: { title: "Species Distribution Maps", authRequired: true },
    component: () => import("../views/census/spatial-analytics/SpeciesDistributionMapsView"),
  },
  {
    path: "/census/species-distribution-census",
    name: "census-species-distribution-census",
    meta: { title: "Species Distribution Census", authRequired: true },
    component: () => import("../views/census/spatial-analytics/SpeciesDistributionCensusView"),
  },

  // Endangered Species Monitoring Routes
  {
    path: "/endangered-species",
    name: "endangered-species-list",
    meta: { title: "Endangered Species Monitoring", authRequired: true },
    component: () => import("../views/endangered-species/EndangeredSpeciesList"),
  },
  {
    path: "/endangered-species/dashboard",
    name: "endangered-species-dashboard",
    meta: { title: "Endangered Species Dashboard", authRequired: true },
    component: () => import("../views/endangered-species/EndangeredSpeciesDashboard"),
  },
];